
  if (!customElements.get('upsell-add-to-cart')) {
    class UpsellAddToCart extends HTMLElement {
      constructor() {
        super();
        this.button = null;
        this.iconSpan = null;
        this.spinner = null;
        this.boundHandleClick = this.handleClick.bind(this);
      }

      connectedCallback() {
        this.button = this.querySelector('button');
        if (!this.button) return;

        this.iconSpan = this.button.querySelector('span');
        this.spinner = this.button.querySelector('.loading__spinner');

        this.button.addEventListener('click', this.boundHandleClick);
      }

      disconnectedCallback() {
        if (this.button) {
          this.button.removeEventListener('click', this.boundHandleClick);
        }
      }

      handleClick(e) {
        e.preventDefault();

        if (this.button.disabled || this.button.classList.contains('loading')) {
          return;
        }

        const variantId = this.button.dataset.variantId;
        const quantity = parseInt(this.button.dataset.quantity) || 1;

        this.addToCart(variantId, quantity);
      }

      async addToCart(variantId, quantity) {
        try {
          this.setLoadingState(true);

          const formData = this.buildFormData(variantId, quantity);
          const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: formData,
          });

          const data = await response.json();

          if (data.status === 422 || data.status === 'error') {
            this.handleError(data);
          } else {
            this.handleSuccess(variantId, data);
          }
        } catch (error) {
          console.error('Error adding to cart:', error);
          alert('Error adding product to cart. Please try again.');
        } finally {
          this.setLoadingState(false);
        }
      }

      buildFormData(variantId, quantity) {
        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', quantity);

        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && cartDrawer.getSectionsToRender) {
          const sections = cartDrawer
            .getSectionsToRender()
            .map((section) => section.id)
            .join(',');
          formData.append('sections', sections);
          formData.append('sections_url', window.location.pathname);
        }

        return formData;
      }

      handleSuccess(variantId, data) {
        // Fire the analytics event HERE -- in the same path that commits the cart, after the
        // POST came back clean. A cart button with no event does not fail loudly: the funnel
        // reads "nobody wants this" when the truth is "nobody measured it", and we burn spend
        // learning nothing about the market. This commit sat unmeasured because the ATC gate
        // brace-matches click listeners and the cart here commits from an async class method.
        try {
          posthog.capture('add_to_cart', {
            offer: 'aughs-leaky-gut',
            variant_id: variantId,
            source: 'cart-upsell',
            page: 'core-n-reasons-expert',
          });
        } catch (e) {}

        // Publish cart update event
        if (typeof PUB_SUB_EVENTS !== 'undefined' && typeof publish !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'cart-upsell',
            productVariantId: variantId,
            cartData: data,
          });
        }

        // Render cart contents
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && cartDrawer.renderContents && data.sections) {
          cartDrawer.renderContents(data);
        }
      }

      handleError(data) {
        console.error('Error adding to cart:', data);
        alert(data.description || data.message || 'Error adding product to cart');
      }

      setLoadingState(isLoading) {
        if (!this.button) return;

        if (isLoading) {
          this.button.classList.add('loading');
          this.button.disabled = true;
          if (this.iconSpan) this.iconSpan.classList.add('hidden');
          if (this.spinner) this.spinner.classList.remove('hidden');
        } else {
          this.button.classList.remove('loading');
          this.button.disabled = false;
          if (this.iconSpan) this.iconSpan.classList.remove('hidden');
          if (this.spinner) this.spinner.classList.add('hidden');
        }
      }
    }

    customElements.define('upsell-add-to-cart', UpsellAddToCart);
  }
